import CurrencyIndex from "@/views/directory/currency/CurrencyIndex.vue";

const currency = [
    {
        path: '/currencies',
        name: 'currencies',
        component: CurrencyIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default currency;
